export default __webpack_public_path__ + "/dist/images/googleplay.72ac0fdbd6f737bc9b5d5aa7aa0777da.png";